/*
 * Lib Module Secret.js 
 */

Lib.Secret = (function () {
    var self = {};

    $(Lib).on('document.ready', function () {
        self.bindSecrets($('[data-secret]'));
    });

    /**
     * Bind secrets
     * @param secrets
     */
    self.bindSecrets = function (secrets) {

        // Get the secret wrapping div
        var secretsParents = secrets.parent().parent();

        // On click of the wrapper
        secretsParents.on('click', function () {

            // Get the secret
            var secret = $(this).find('div.col-right span[data-secret]');

            // Make it visible, or not!
            $(this).toggleClass('secret-visible');

            // If its currently visible
            if (secret.data('secret-toggle') === true) {

                // Make it not-visible
                secret.html(secret.data('secret-mask'));
                secret.data('secret-toggle', false);
            } else {

                // Make it visible!
                secret.html($("<div />").html(secret.data('secret')).text());
                secret.data('secret-toggle', true);
            }
        });
    };

    return self;

})();
